import axios from "axios";
import Papa from "papaparse";

const baseUrl = "https://veclogic.com/backend";
export const uploadCSV = async (formData) => {
  try {
    const response = await axios.post(`${baseUrl}/import-csv`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw new Error("Upload failed");
  }
};

export const clearDatabase = async (storeId, userId) => {
  try {
    const response = await fetch(`${baseUrl}/clear-embeddings`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ storeId, userId }),
    });
    if (!response.ok) {
      throw new Error("Failed to clear database");
    }
  } catch (error) {
    console.error("Error clearing database:", error);
    throw error;
  }
};

export const loadPresetCSV = async (fileName) => {
  try {
    const response = await axios.get(`${process.env.PUBLIC_URL}/${fileName}`, {
      responseType: "blob",
    });
    const csvData = await response.data.text();

    return new Promise((resolve, reject) => {
      Papa.parse(csvData, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const data = results.data;
          resolve(data);
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  } catch (error) {
    throw new Error("Failed to load preset CSV");
  }
};
